import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import IconButton from "@mui/material/IconButton";
import { Grid } from "@mui/material";
import Cards from "../card/Cards";
import { CollapsedContainer } from "./CollapsedContainer";
import { contactTabs } from "../../tabs/contactTabs";
import useAnalyticsApi from "../../../hooks/useAnalyticsApi";
import { useDispatch, useSelector } from "react-redux";
import { setAnalyticsData } from "../../../store/Contact/analyticsSlice";
import { axiosFunction } from "../../commonFunctions";
import { v2ReactURL } from "../../../utils/constant";

const Collapsed = ({
  tabView,
  setRows,
  setPagination,
  pageOption,
  setSearchValue,
  setLoadingData,
}) => {
  const { sortingData } = useSelector((state) => state);
  const [open, setOpen] = useState(contactTabs.map(() => false));
  const [selectedCard, setSelectedCard] = useState(contactTabs.map(() => null));

  const dispatch = useDispatch();
  const contactType =
    tabView === "customers"
      ? "customers"
      : tabView === "suppliers"
      ? "suppliers"
      : "transport";

  const { fetchAnalyticsApi, analyticsData } = useAnalyticsApi();

  useEffect(() => {
    fetchAnalyticsApi(contactType);
  }, [contactType]);

  useEffect(() => {
    setSelectedCard([]);
  }, [contactType]);

  const toggleTab = (index) => {
    setOpen((prevOpen) => {
      const newOpenStates = [...prevOpen];
      newOpenStates[index] = !newOpenStates[index];
      return newOpenStates;
    });
  };

  const handleCardClick = async (data, index) => {
    setSearchValue("");

    const updatedCard = () => {
      const newSelectedCards = selectedCard;
      newSelectedCards[tabView] =
        index === newSelectedCards[tabView] ? null : index;
      return newSelectedCards;
    };

    const updatedSelectedCardValue = updatedCard();

    setSelectedCard(updatedSelectedCardValue);

    const apiFieldObject = {
      newCustomerCount: 0,
      repeatCustomerCount: 0,
      notPurchasedLastSixMonths: 0,
      totalOutstandingCustomers: 0,
      totalPayableSupplier: 0,
      totalOrderValue: 0,
      totalTransporterOrderValue: 0,
    };

    if (data.apiField) {
      apiFieldObject[data.apiField] =
        index === updatedSelectedCardValue[tabView] ? 1 : 0;
    }

    dispatch(setAnalyticsData(apiFieldObject));

    setLoadingData(true);
    const res = await axiosFunction(
      `${v2ReactURL}/contact/${contactType}/customdatatable`,
      "POST",
      {
        searchValue: "",
        branchIds: [64],
        contactIds: [],
        isMobNoVerify: "all",
        membershipIds: [],
        contactType: "0",
        length: parseInt(pageOption),
        start: 0,
        draw: 1,
        ...apiFieldObject,
        ...sortingData,
      }
    );

    const contactList = res.data.data.map((col, index) => ({
      ...col,
      index: index + 1,
      checked: false,
    }));
    setLoadingData(false);
    setPagination(res.data.dataTableMetaDTO);
    setRows(contactList);
  };

  const customerData = [
    {
      title: "New",
      value: analyticsData?.newCustomerCount,
      tooltipMessage: "New customer from past 1 Month",
      index: 0,
      apiField: "newCustomerCount",
    },
    {
      title: "Repetitive",
      value: analyticsData?.repeatCustomerCount,
      tooltipMessage: "Customer who purchased more than twice in a month",
      index: 1,
      apiField: "repeatCustomerCount",
    },
    {
      title: "Lost",
      value: analyticsData?.lostCustomerCount,
      tooltipMessage: "No purchase in a month.",
      index: 2,
      apiField: "notPurchasedLastSixMonths",
    },
    {
      title: "Receivables",
      value: analyticsData?.receivablesCustomerCount,
      tooltipMessage: "Total Outstanding Of Customer",
      index: 3,
      apiField: "totalOutstandingCustomers",
    },
    {
      title: "Avg Bill Value",
      value: analyticsData?.avgCustomerCount,
      index: 4,
    },
  ];

  const supplierData = [
    {
      title: "Total Vendor",
      value: analyticsData?.supplierCount,
      tooltipMessage: "Total Supplier/Vendor",
      index: 0,
    },
    {
      title: "Total Payable",
      value:
        analyticsData?.supplierTotalPayableSum !== "NaN"
          ? analyticsData?.supplierTotalPayableSum
          : 0,
      tooltipMessage: "Total payable of supplier/vendor",
      index: 1,
      apiField: "totalPayableSupplier",
    },
    {
      title: "Total Order Value",
      value: analyticsData?.totalSupplierOrderValue,
      tooltipMessage: "Total order value of current year",
      index: 2,
    },
    {
      title: "Total Order Count",
      value: analyticsData?.sumOfTotalSupplierOrderCount,
      tooltipMessage: "Total order count of current year",
      index: 3,
      apiField: "totalOrderValue",
    },
  ];

  const transportData = [
    {
      title: "Total Transporter",
      value: analyticsData?.totaltransportercount,
      tooltipMessage: "Total Transporter",
      index: 0,
      apiField: "totaltransportercount",
    },
    {
      title: "Order Value Transported",
      value: analyticsData?.totaltransporterordervalue,
      tooltipMessage: "Total value of product transported",
      index: 1,
      apiField: "totaltransporterordervalue",
    },
    {
      title: "Total Cost",
      value: "0",
      tooltipMessage: "Total Transportation Cost",
      index: 2,
    },
  ];

  const tabsData =
    tabView === "customers"
      ? customerData
      : tabView === "suppliers"
      ? supplierData
      : transportData;

  const tabViewMenu =
    tabView === "customers" ? 0 : tabView === "suppliers" ? 1 : 2;

  return (
    <CollapsedContainer>
      <Card className="card-container" style={{position : 'relative'}}>
        <CardHeader
          className="card-header"
          action={
            <div
              onClick={() => toggleTab(tabViewMenu)}
              className="analytics-container"
            >
              {!open[tabViewMenu] ? <span>View Analytics</span> : ""}
              <IconButton
                aria-label="expand"
                size="small"
                className="icon-button"
              >
                {open[tabViewMenu] ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </IconButton>
            </div>
          }
        ></CardHeader>

        <div className="collapse-content" style={{position : 'absolute', top:0,left:0,width:'100%',}}>
          <Collapse in={open[tabViewMenu]} timeout="auto" unmountOnExit>
            <CardContent>
              <Grid
                container
                item
                lg={12}
                spacing={2}
                alignItems="center"
                className="collapseScroll"
              >
                {tabsData.map((data, index) => {
                  return (
                    <Grid item xs="auto" key={index}>
                      <Cards
                        tooltip={data.tooltipMessage}
                        title={data.title}
                        value={data.value}
                        index={data.index}
                        isSelected={selectedCard[tabView] === index}
                        onClick={() => handleCardClick(data, index)}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </CardContent>
          </Collapse>
        </div>
      </Card>
    </CollapsedContainer>
  );
};

export default Collapsed;
